module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "sub-header"
  }, [_c('div', {
    staticClass: "width-wrapper relative"
  }, [_c('div', {
    staticClass: "page-title page-title-ph"
  }, [_vm._v(_vm._s(_vm.pharmacy.title) + " ["), _vm._l((_vm.pharmacy.categories), function(category) {
    return _c('span', {
      staticClass: "pharmacy-list-item__cats-item"
    }, [_vm._v(_vm._s(category.title))])
  }), _vm._v("]")], 2), _vm._v(" "), _c('div', {
    staticClass: "pharmacy-header__cats"
  }), _vm._v(" "), _c('div', {
    staticClass: "pharmacy-header__supervisor"
  }), _vm._v(" "), _c('div', {
    staticClass: "header__save"
  }, [(_vm.$route.path.includes(("/pharmacies/" + (_vm.$route.params.id) + "/racks/"))) ? _c('a', {
    staticClass: "button",
    attrs: {
      "href": "#",
      "title": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.print.apply(null, arguments)
      }
    }
  }, [_vm._v("Печать")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.role == 'HM') ? _c('span', [_c('router-link', {
    staticClass: "button button--inverse",
    attrs: {
      "title": "",
      "to": {
        path: ("/pharmacies/" + (_vm.$route.params.id) + "/racks/new/")
      }
    }
  }, [_vm._v("Добавить стеллаж")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "#",
      "title": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save.apply(null, arguments)
      }
    }
  }, [_vm._v("Сохранить изменения")])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.role == 'PM') ? _c('span', {
    staticClass: "version-info"
  }, [_vm._v("\n\n          Версия " + _vm._s(_vm.pharmacy.version.title) + " [" + _vm._s(_vm.statuses[_vm.pharmacy.version.status]) + "]\n        "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pharmacy.version.status === 'NEW'),
      expression: "pharmacy.version.status === 'NEW'"
    }],
    staticClass: "button",
    attrs: {
      "href": "#",
      "title": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeVersionStatus('SEEN')
      }
    }
  }, [_vm._v("Взять работу")]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pharmacy.version.status === 'SEEN'),
      expression: "pharmacy.version.status === 'SEEN'"
    }],
    staticClass: "button",
    attrs: {
      "href": "#",
      "title": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeVersionStatus('DONE')
      }
    }
  }, [_vm._v("Расставлено")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "header-tabs"
  }, [_c('router-link', {
    staticClass: "header-tabs__link",
    attrs: {
      "activeClass": "header-tabs__link-active",
      "exact": "",
      "to": ("/pharmacies/" + (_vm.$route.params.id) + "/")
    }
  }, [_vm._v("Планировка")]), _vm._v(" "), _c('router-link', {
    staticClass: "header-tabs__link",
    attrs: {
      "activeClass": "header-tabs__link-active",
      "to": ("/pharmacies/" + (_vm.$route.params.id) + "/racks/")
    }
  }, [_vm._v("Стеллажи")])], 1)])]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f0d8f7d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pharmacy/Pharmacy.vue
// module id = 233
// module chunks = 1